import { Injectable } from '@angular/core';
import { Http, Weaver, Wrapper } from '@skylab-angular-shared/core';
import { CompanyParametersRepositoryBase } from '@skylab-shared/business';
export { CompanyParametersRepositoryBase };

@Injectable({ providedIn: 'root'})
@Wrapper(CompanyParametersRepositoryBase)
export class CompanyParametersRepository {
    public constructor(
        weaver: Weaver,
        http: Http
    ) { }
}
